import chroma from "chroma-js";
import type { VenueBrand } from "../MobileOrderingMenu/schema";

interface VenueCssVariables {
  "--brand-color": string;
  "--brand-contrast-color": string;
  "--brand-foreground-color": chroma.Color;
  "--brand-background-color": chroma.Color;
}

export interface VenueBrandForContext extends VenueBrand {
  backgroundColor: chroma.Color;
  foregroundColor: chroma.Color;
  brandContrastColor: "white" | "black";
  isBrutalist: boolean;
  isSimple: boolean;
  isElegant: boolean;
  isPlayful: boolean;
  cssVariables: VenueCssVariables;
}
const findContrastColor = (brandColor: string) => {
  const contrastWith = (color: string) => chroma.contrast(brandColor, color);
  return contrastWith("white") > contrastWith("black") ? "white" : "black";
};

const venueBrandForContext = (venueBrand: VenueBrand): VenueBrandForContext => {
  const colorScale = chroma
    .bezier([venueBrand.brandColor || "white", "white"])
    .scale()
    .correctLightness();
  const brandContrastColor = findContrastColor(
    venueBrand.brandColor || "white"
  );
  const foregroundColor = colorScale(0.95);
  const backgroundColor = colorScale(0.98);
  return {
    backgroundColor,
    foregroundColor,
    ...venueBrand,
    brandContrastColor,
    isBrutalist: venueBrand.brandStyle == "brutalist",
    isSimple: venueBrand.brandStyle == "simple" || !venueBrand.brandStyle,
    isElegant: venueBrand.brandStyle == "elegant",
    isPlayful: venueBrand.brandStyle == "playful",
    cssVariables: {
      "--brand-color": venueBrand.brandColor,
      "--brand-contrast-color": brandContrastColor,
      "--brand-foreground-color": foregroundColor,
      "--brand-background-color": backgroundColor,
    },
  };
};

export default venueBrandForContext;
